export default [
  {
    type: 'constructor',
    inputs: [],
    stateMutability: 'nonpayable',
  },
  {
    type: 'function',
    name: 'UPGRADE_INTERFACE_VERSION',
    inputs: [],
    outputs: [
      {
        name: '',
        type: 'string',
        internalType: 'string',
      },
    ],
    stateMutability: 'view',
  },
  {
    type: 'function',
    name: 'acceptOwnership',
    inputs: [],
    outputs: [],
    stateMutability: 'nonpayable',
  },
  {
    type: 'function',
    name: 'calculateERC20zActivate',
    inputs: [
      {
        name: 'collection',
        type: 'address',
        internalType: 'address',
      },
      {
        name: 'tokenId',
        type: 'uint256',
        internalType: 'uint256',
      },
      {
        name: 'erc20zAddress',
        type: 'address',
        internalType: 'address',
      },
    ],
    outputs: [
      {
        name: '',
        type: 'tuple',
        internalType: 'struct IZoraTimedSaleStrategy.ERC20zActivate',
        components: [
          {
            name: 'finalTotalERC20ZSupply',
            type: 'uint256',
            internalType: 'uint256',
          },
          {
            name: 'erc20Reserve',
            type: 'uint256',
            internalType: 'uint256',
          },
          {
            name: 'erc20Liquidity',
            type: 'uint256',
            internalType: 'uint256',
          },
          {
            name: 'excessERC20',
            type: 'uint256',
            internalType: 'uint256',
          },
          {
            name: 'excessERC1155',
            type: 'uint256',
            internalType: 'uint256',
          },
          {
            name: 'additionalERC1155ToMint',
            type: 'uint256',
            internalType: 'uint256',
          },
          {
            name: 'final1155Supply',
            type: 'uint256',
            internalType: 'uint256',
          },
        ],
      },
    ],
    stateMutability: 'view',
  },
  {
    type: 'function',
    name: 'computeRewards',
    inputs: [
      {
        name: 'quantity',
        type: 'uint256',
        internalType: 'uint256',
      },
    ],
    outputs: [
      {
        name: '',
        type: 'tuple',
        internalType: 'struct IZoraTimedSaleStrategy.RewardsSettings',
        components: [
          {
            name: 'totalReward',
            type: 'uint256',
            internalType: 'uint256',
          },
          {
            name: 'creatorReward',
            type: 'uint256',
            internalType: 'uint256',
          },
          {
            name: 'createReferralReward',
            type: 'uint256',
            internalType: 'uint256',
          },
          {
            name: 'mintReferralReward',
            type: 'uint256',
            internalType: 'uint256',
          },
          {
            name: 'marketReward',
            type: 'uint256',
            internalType: 'uint256',
          },
          {
            name: 'zoraReward',
            type: 'uint256',
            internalType: 'uint256',
          },
        ],
      },
    ],
    stateMutability: 'pure',
  },
  {
    type: 'function',
    name: 'contractName',
    inputs: [],
    outputs: [
      {
        name: '',
        type: 'string',
        internalType: 'string',
      },
    ],
    stateMutability: 'pure',
  },
  {
    type: 'function',
    name: 'contractURI',
    inputs: [],
    outputs: [
      {
        name: '',
        type: 'string',
        internalType: 'string',
      },
    ],
    stateMutability: 'pure',
  },
  {
    type: 'function',
    name: 'contractVersion',
    inputs: [],
    outputs: [
      {
        name: '',
        type: 'string',
        internalType: 'string',
      },
    ],
    stateMutability: 'pure',
  },
  {
    type: 'function',
    name: 'erc20zImpl',
    inputs: [],
    outputs: [
      {
        name: '',
        type: 'address',
        internalType: 'address',
      },
    ],
    stateMutability: 'view',
  },
  {
    type: 'function',
    name: 'getCreateReferral',
    inputs: [
      {
        name: 'collection',
        type: 'address',
        internalType: 'address',
      },
      {
        name: 'tokenId',
        type: 'uint256',
        internalType: 'uint256',
      },
    ],
    outputs: [
      {
        name: 'createReferral',
        type: 'address',
        internalType: 'address',
      },
    ],
    stateMutability: 'view',
  },
  {
    type: 'function',
    name: 'initialize',
    inputs: [
      {
        name: '_defaultOwner',
        type: 'address',
        internalType: 'address',
      },
      {
        name: '_zoraRewardRecipient',
        type: 'address',
        internalType: 'address',
      },
      {
        name: '_erc20zImpl',
        type: 'address',
        internalType: 'address',
      },
      {
        name: '_protocolRewards',
        type: 'address',
        internalType: 'contract IProtocolRewards',
      },
    ],
    outputs: [],
    stateMutability: 'nonpayable',
  },
  {
    type: 'function',
    name: 'launchMarket',
    inputs: [
      {
        name: 'collection',
        type: 'address',
        internalType: 'address',
      },
      {
        name: 'tokenId',
        type: 'uint256',
        internalType: 'uint256',
      },
    ],
    outputs: [],
    stateMutability: 'nonpayable',
  },
  {
    type: 'function',
    name: 'mint',
    inputs: [
      {
        name: 'mintTo',
        type: 'address',
        internalType: 'address',
      },
      {
        name: 'quantity',
        type: 'uint256',
        internalType: 'uint256',
      },
      {
        name: 'collection',
        type: 'address',
        internalType: 'address',
      },
      {
        name: 'tokenId',
        type: 'uint256',
        internalType: 'uint256',
      },
      {
        name: 'mintReferral',
        type: 'address',
        internalType: 'address',
      },
      {
        name: 'comment',
        type: 'string',
        internalType: 'string',
      },
    ],
    outputs: [],
    stateMutability: 'payable',
  },
  {
    type: 'function',
    name: 'owner',
    inputs: [],
    outputs: [
      {
        name: '',
        type: 'address',
        internalType: 'address',
      },
    ],
    stateMutability: 'view',
  },
  {
    type: 'function',
    name: 'pendingOwner',
    inputs: [],
    outputs: [
      {
        name: '',
        type: 'address',
        internalType: 'address',
      },
    ],
    stateMutability: 'view',
  },
  {
    type: 'function',
    name: 'protocolRewards',
    inputs: [],
    outputs: [
      {
        name: '',
        type: 'address',
        internalType: 'contract IProtocolRewards',
      },
    ],
    stateMutability: 'view',
  },
  {
    type: 'function',
    name: 'proxiableUUID',
    inputs: [],
    outputs: [
      {
        name: '',
        type: 'bytes32',
        internalType: 'bytes32',
      },
    ],
    stateMutability: 'view',
  },
  {
    type: 'function',
    name: 'renounceOwnership',
    inputs: [],
    outputs: [],
    stateMutability: 'nonpayable',
  },
  {
    type: 'function',
    name: 'requestMint',
    inputs: [
      {
        name: '',
        type: 'address',
        internalType: 'address',
      },
      {
        name: '',
        type: 'uint256',
        internalType: 'uint256',
      },
      {
        name: '',
        type: 'uint256',
        internalType: 'uint256',
      },
      {
        name: '',
        type: 'uint256',
        internalType: 'uint256',
      },
      {
        name: '',
        type: 'bytes',
        internalType: 'bytes',
      },
    ],
    outputs: [
      {
        name: '',
        type: 'tuple',
        internalType: 'struct ICreatorCommands.CommandSet',
        components: [
          {
            name: 'commands',
            type: 'tuple[]',
            internalType: 'struct ICreatorCommands.Command[]',
            components: [
              {
                name: 'method',
                type: 'uint8',
                internalType: 'enum ICreatorCommands.CreatorActions',
              },
              {
                name: 'args',
                type: 'bytes',
                internalType: 'bytes',
              },
            ],
          },
          {
            name: 'at',
            type: 'uint256',
            internalType: 'uint256',
          },
        ],
      },
    ],
    stateMutability: 'pure',
  },
  {
    type: 'function',
    name: 'sale',
    inputs: [
      {
        name: 'collection',
        type: 'address',
        internalType: 'address',
      },
      {
        name: 'tokenId',
        type: 'uint256',
        internalType: 'uint256',
      },
    ],
    outputs: [
      {
        name: '',
        type: 'tuple',
        internalType: 'struct IZoraTimedSaleStrategy.SaleStorage',
        components: [
          {
            name: 'erc20zAddress',
            type: 'address',
            internalType: 'address payable',
          },
          {
            name: 'saleStart',
            type: 'uint64',
            internalType: 'uint64',
          },
          {
            name: 'poolAddress',
            type: 'address',
            internalType: 'address',
          },
          {
            name: 'saleEnd',
            type: 'uint64',
            internalType: 'uint64',
          },
          {
            name: 'secondaryActivated',
            type: 'bool',
            internalType: 'bool',
          },
        ],
      },
    ],
    stateMutability: 'view',
  },
  {
    type: 'function',
    name: 'saleV2',
    inputs: [
      {
        name: 'collection',
        type: 'address',
        internalType: 'address',
      },
      {
        name: 'tokenId',
        type: 'uint256',
        internalType: 'uint256',
      },
    ],
    outputs: [
      {
        name: '',
        type: 'tuple',
        internalType: 'struct IZoraTimedSaleStrategy.SaleData',
        components: [
          {
            name: 'saleStart',
            type: 'uint64',
            internalType: 'uint64',
          },
          {
            name: 'marketCountdown',
            type: 'uint64',
            internalType: 'uint64',
          },
          {
            name: 'saleEnd',
            type: 'uint64',
            internalType: 'uint64',
          },
          {
            name: 'secondaryActivated',
            type: 'bool',
            internalType: 'bool',
          },
          {
            name: 'minimumMarketEth',
            type: 'uint256',
            internalType: 'uint256',
          },
          {
            name: 'poolAddress',
            type: 'address',
            internalType: 'address',
          },
          {
            name: 'erc20zAddress',
            type: 'address',
            internalType: 'address payable',
          },
          {
            name: 'name',
            type: 'string',
            internalType: 'string',
          },
          {
            name: 'symbol',
            type: 'string',
            internalType: 'string',
          },
        ],
      },
    ],
    stateMutability: 'view',
  },
  {
    type: 'function',
    name: 'setSale',
    inputs: [
      {
        name: 'tokenId',
        type: 'uint256',
        internalType: 'uint256',
      },
      {
        name: 'salesConfig',
        type: 'tuple',
        internalType: 'struct IZoraTimedSaleStrategy.SalesConfig',
        components: [
          {
            name: 'saleStart',
            type: 'uint64',
            internalType: 'uint64',
          },
          {
            name: 'saleEnd',
            type: 'uint64',
            internalType: 'uint64',
          },
          {
            name: 'name',
            type: 'string',
            internalType: 'string',
          },
          {
            name: 'symbol',
            type: 'string',
            internalType: 'string',
          },
        ],
      },
    ],
    outputs: [],
    stateMutability: 'nonpayable',
  },
  {
    type: 'function',
    name: 'setSaleV2',
    inputs: [
      {
        name: 'tokenId',
        type: 'uint256',
        internalType: 'uint256',
      },
      {
        name: 'salesConfig',
        type: 'tuple',
        internalType: 'struct IZoraTimedSaleStrategy.SalesConfigV2',
        components: [
          {
            name: 'saleStart',
            type: 'uint64',
            internalType: 'uint64',
          },
          {
            name: 'marketCountdown',
            type: 'uint64',
            internalType: 'uint64',
          },
          {
            name: 'minimumMarketEth',
            type: 'uint256',
            internalType: 'uint256',
          },
          {
            name: 'name',
            type: 'string',
            internalType: 'string',
          },
          {
            name: 'symbol',
            type: 'string',
            internalType: 'string',
          },
        ],
      },
    ],
    outputs: [],
    stateMutability: 'nonpayable',
  },
  {
    type: 'function',
    name: 'setZoraRewardRecipient',
    inputs: [
      {
        name: 'recipient',
        type: 'address',
        internalType: 'address',
      },
    ],
    outputs: [],
    stateMutability: 'nonpayable',
  },
  {
    type: 'function',
    name: 'supportsInterface',
    inputs: [
      {
        name: 'interfaceId',
        type: 'bytes4',
        internalType: 'bytes4',
      },
    ],
    outputs: [
      {
        name: '',
        type: 'bool',
        internalType: 'bool',
      },
    ],
    stateMutability: 'pure',
  },
  {
    type: 'function',
    name: 'transferOwnership',
    inputs: [
      {
        name: 'newOwner',
        type: 'address',
        internalType: 'address',
      },
    ],
    outputs: [],
    stateMutability: 'nonpayable',
  },
  {
    type: 'function',
    name: 'uniswapV3SwapCallback',
    inputs: [
      {
        name: 'amount0Delta',
        type: 'int256',
        internalType: 'int256',
      },
      {
        name: 'amount1Delta',
        type: 'int256',
        internalType: 'int256',
      },
      {
        name: '',
        type: 'bytes',
        internalType: 'bytes',
      },
    ],
    outputs: [],
    stateMutability: 'nonpayable',
  },
  {
    type: 'function',
    name: 'updateSale',
    inputs: [
      {
        name: 'tokenId',
        type: 'uint256',
        internalType: 'uint256',
      },
      {
        name: 'newStartTime',
        type: 'uint64',
        internalType: 'uint64',
      },
      {
        name: 'newMarketCountdown',
        type: 'uint64',
        internalType: 'uint64',
      },
    ],
    outputs: [],
    stateMutability: 'nonpayable',
  },
  {
    type: 'function',
    name: 'upgradeToAndCall',
    inputs: [
      {
        name: 'newImplementation',
        type: 'address',
        internalType: 'address',
      },
      {
        name: 'data',
        type: 'bytes',
        internalType: 'bytes',
      },
    ],
    outputs: [],
    stateMutability: 'payable',
  },
  {
    type: 'event',
    name: 'Initialized',
    inputs: [
      {
        name: 'version',
        type: 'uint64',
        indexed: false,
        internalType: 'uint64',
      },
    ],
    anonymous: false,
  },
  {
    type: 'event',
    name: 'MarketLaunched',
    inputs: [
      {
        name: 'collection',
        type: 'address',
        indexed: true,
        internalType: 'address',
      },
      {
        name: 'tokenId',
        type: 'uint256',
        indexed: true,
        internalType: 'uint256',
      },
      {
        name: 'erc20zAddress',
        type: 'address',
        indexed: false,
        internalType: 'address',
      },
      {
        name: 'poolAddress',
        type: 'address',
        indexed: false,
        internalType: 'address',
      },
    ],
    anonymous: false,
  },
  {
    type: 'event',
    name: 'MintComment',
    inputs: [
      {
        name: 'sender',
        type: 'address',
        indexed: true,
        internalType: 'address',
      },
      {
        name: 'collection',
        type: 'address',
        indexed: true,
        internalType: 'address',
      },
      {
        name: 'tokenId',
        type: 'uint256',
        indexed: true,
        internalType: 'uint256',
      },
      {
        name: 'quantity',
        type: 'uint256',
        indexed: false,
        internalType: 'uint256',
      },
      {
        name: 'comment',
        type: 'string',
        indexed: false,
        internalType: 'string',
      },
    ],
    anonymous: false,
  },
  {
    type: 'event',
    name: 'OwnershipTransferStarted',
    inputs: [
      {
        name: 'previousOwner',
        type: 'address',
        indexed: true,
        internalType: 'address',
      },
      {
        name: 'newOwner',
        type: 'address',
        indexed: true,
        internalType: 'address',
      },
    ],
    anonymous: false,
  },
  {
    type: 'event',
    name: 'OwnershipTransferred',
    inputs: [
      {
        name: 'previousOwner',
        type: 'address',
        indexed: true,
        internalType: 'address',
      },
      {
        name: 'newOwner',
        type: 'address',
        indexed: true,
        internalType: 'address',
      },
    ],
    anonymous: false,
  },
  {
    type: 'event',
    name: 'SaleSet',
    inputs: [
      {
        name: 'collection',
        type: 'address',
        indexed: true,
        internalType: 'address',
      },
      {
        name: 'tokenId',
        type: 'uint256',
        indexed: true,
        internalType: 'uint256',
      },
      {
        name: 'salesConfig',
        type: 'tuple',
        indexed: false,
        internalType: 'struct IZoraTimedSaleStrategy.SalesConfig',
        components: [
          {
            name: 'saleStart',
            type: 'uint64',
            internalType: 'uint64',
          },
          {
            name: 'saleEnd',
            type: 'uint64',
            internalType: 'uint64',
          },
          {
            name: 'name',
            type: 'string',
            internalType: 'string',
          },
          {
            name: 'symbol',
            type: 'string',
            internalType: 'string',
          },
        ],
      },
      {
        name: 'erc20zAddress',
        type: 'address',
        indexed: false,
        internalType: 'address',
      },
      {
        name: 'poolAddress',
        type: 'address',
        indexed: false,
        internalType: 'address',
      },
      {
        name: 'mintFee',
        type: 'uint256',
        indexed: false,
        internalType: 'uint256',
      },
    ],
    anonymous: false,
  },
  {
    type: 'event',
    name: 'SaleSetV2',
    inputs: [
      {
        name: 'collection',
        type: 'address',
        indexed: true,
        internalType: 'address',
      },
      {
        name: 'tokenId',
        type: 'uint256',
        indexed: true,
        internalType: 'uint256',
      },
      {
        name: 'saleData',
        type: 'tuple',
        indexed: false,
        internalType: 'struct IZoraTimedSaleStrategy.SaleData',
        components: [
          {
            name: 'saleStart',
            type: 'uint64',
            internalType: 'uint64',
          },
          {
            name: 'marketCountdown',
            type: 'uint64',
            internalType: 'uint64',
          },
          {
            name: 'saleEnd',
            type: 'uint64',
            internalType: 'uint64',
          },
          {
            name: 'secondaryActivated',
            type: 'bool',
            internalType: 'bool',
          },
          {
            name: 'minimumMarketEth',
            type: 'uint256',
            internalType: 'uint256',
          },
          {
            name: 'poolAddress',
            type: 'address',
            internalType: 'address',
          },
          {
            name: 'erc20zAddress',
            type: 'address',
            internalType: 'address payable',
          },
          {
            name: 'name',
            type: 'string',
            internalType: 'string',
          },
          {
            name: 'symbol',
            type: 'string',
            internalType: 'string',
          },
        ],
      },
      {
        name: 'mintFee',
        type: 'uint256',
        indexed: false,
        internalType: 'uint256',
      },
    ],
    anonymous: false,
  },
  {
    type: 'event',
    name: 'Upgraded',
    inputs: [
      {
        name: 'implementation',
        type: 'address',
        indexed: true,
        internalType: 'address',
      },
    ],
    anonymous: false,
  },
  {
    type: 'event',
    name: 'ZoraRewardRecipientUpdated',
    inputs: [
      {
        name: 'prevRecipient',
        type: 'address',
        indexed: true,
        internalType: 'address',
      },
      {
        name: 'newRecipient',
        type: 'address',
        indexed: true,
        internalType: 'address',
      },
    ],
    anonymous: false,
  },
  {
    type: 'event',
    name: 'ZoraTimedSaleStrategyRewards',
    inputs: [
      {
        name: 'collection',
        type: 'address',
        indexed: true,
        internalType: 'address',
      },
      {
        name: 'tokenId',
        type: 'uint256',
        indexed: true,
        internalType: 'uint256',
      },
      {
        name: 'creator',
        type: 'address',
        indexed: false,
        internalType: 'address',
      },
      {
        name: 'creatorReward',
        type: 'uint256',
        indexed: false,
        internalType: 'uint256',
      },
      {
        name: 'createReferral',
        type: 'address',
        indexed: false,
        internalType: 'address',
      },
      {
        name: 'createReferralReward',
        type: 'uint256',
        indexed: false,
        internalType: 'uint256',
      },
      {
        name: 'mintReferral',
        type: 'address',
        indexed: false,
        internalType: 'address',
      },
      {
        name: 'mintReferralReward',
        type: 'uint256',
        indexed: false,
        internalType: 'uint256',
      },
      {
        name: 'market',
        type: 'address',
        indexed: false,
        internalType: 'address',
      },
      {
        name: 'marketReward',
        type: 'uint256',
        indexed: false,
        internalType: 'uint256',
      },
      {
        name: 'zoraRecipient',
        type: 'address',
        indexed: false,
        internalType: 'address',
      },
      {
        name: 'zoraReward',
        type: 'uint256',
        indexed: false,
        internalType: 'uint256',
      },
    ],
    anonymous: false,
  },
  {
    type: 'error',
    name: 'AddressEmptyCode',
    inputs: [
      {
        name: 'target',
        type: 'address',
        internalType: 'address',
      },
    ],
  },
  {
    type: 'error',
    name: 'AddressInsufficientBalance',
    inputs: [
      {
        name: 'account',
        type: 'address',
        internalType: 'address',
      },
    ],
  },
  {
    type: 'error',
    name: 'AddressZero',
    inputs: [],
  },
  {
    type: 'error',
    name: 'ERC1167FailedCreateClone',
    inputs: [],
  },
  {
    type: 'error',
    name: 'ERC1967InvalidImplementation',
    inputs: [
      {
        name: 'implementation',
        type: 'address',
        internalType: 'address',
      },
    ],
  },
  {
    type: 'error',
    name: 'ERC1967NonPayable',
    inputs: [],
  },
  {
    type: 'error',
    name: 'EndTimeCannotBeInThePast',
    inputs: [],
  },
  {
    type: 'error',
    name: 'FailedInnerCall',
    inputs: [],
  },
  {
    type: 'error',
    name: 'InsufficientFunds',
    inputs: [],
  },
  {
    type: 'error',
    name: 'InvalidInitialization',
    inputs: [],
  },
  {
    type: 'error',
    name: 'MarketAlreadyLaunched',
    inputs: [],
  },
  {
    type: 'error',
    name: 'MarketMinimumNotReached',
    inputs: [],
  },
  {
    type: 'error',
    name: 'MinimumMarketEthNotMet',
    inputs: [],
  },
  {
    type: 'error',
    name: 'NeedsToBeAtLeastOneSaleToStartMarket',
    inputs: [],
  },
  {
    type: 'error',
    name: 'NotInitializing',
    inputs: [],
  },
  {
    type: 'error',
    name: 'OnlyZoraRewardRecipient',
    inputs: [],
  },
  {
    type: 'error',
    name: 'OwnableInvalidOwner',
    inputs: [
      {
        name: 'owner',
        type: 'address',
        internalType: 'address',
      },
    ],
  },
  {
    type: 'error',
    name: 'OwnableUnauthorizedAccount',
    inputs: [
      {
        name: 'account',
        type: 'address',
        internalType: 'address',
      },
    ],
  },
  {
    type: 'error',
    name: 'ReentrancyGuardReentrantCall',
    inputs: [],
  },
  {
    type: 'error',
    name: 'RequestMintInvalidUseMint',
    inputs: [],
  },
  {
    type: 'error',
    name: 'ResetSaleNotAvailable',
    inputs: [],
  },
  {
    type: 'error',
    name: 'SaleAlreadySet',
    inputs: [],
  },
  {
    type: 'error',
    name: 'SaleEnded',
    inputs: [],
  },
  {
    type: 'error',
    name: 'SaleHasNotStarted',
    inputs: [],
  },
  {
    type: 'error',
    name: 'SaleInProgress',
    inputs: [],
  },
  {
    type: 'error',
    name: 'SaleNotSet',
    inputs: [],
  },
  {
    type: 'error',
    name: 'SaleV2AlreadyStarted',
    inputs: [],
  },
  {
    type: 'error',
    name: 'SaleV2Ended',
    inputs: [],
  },
  {
    type: 'error',
    name: 'SaleV2NotSet',
    inputs: [],
  },
  {
    type: 'error',
    name: 'StartTimeCannotBeAfterEndTime',
    inputs: [],
  },
  {
    type: 'error',
    name: 'UUPSUnauthorizedCallContext',
    inputs: [],
  },
  {
    type: 'error',
    name: 'UUPSUnsupportedProxiableUUID',
    inputs: [
      {
        name: 'slot',
        type: 'bytes32',
        internalType: 'bytes32',
      },
    ],
  },
  {
    type: 'error',
    name: 'WrongValueSent',
    inputs: [],
  },
  {
    type: 'error',
    name: 'ZoraCreator1155ContractNeedsToSupportReduceSupply',
    inputs: [],
  },
] as const
